export const pendingPromise = new Promise<never>(() => {});
